var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('video',{ref:"video",attrs:{"id":"v_video","src":_vm.url,"type":"application/x-mpegURL","controls":"","preload":"auto","width":"100%","height":"90%","autoplay":_vm.autoplay,"data-setup":"{}"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }